/**
 * Loading skeleton for Shipping Rules Table
 * Shows placeholder rows for desktop table and cards for mobile
 */
export function ShippingRulesTableLoading() {
  return (
    <div>
      {/* Mobile: Card Skeletons */}
      <div className='grid grid-cols-1 gap-4 p-4 sm:grid-cols-2 lg:hidden'>
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className='rounded-xl border border-sd-border bg-sd-card shadow-sm p-4'
          >
            <div className='animate-pulse space-y-3'>
              {/* Header with switch and name */}
              <div className='flex items-center justify-between'>
                <div className='h-5 w-10 bg-sd-muted rounded-full'></div>
                <div className='h-4 bg-sd-muted rounded w-24'></div>
              </div>
              {/* Carriers */}
              <div className='flex items-center gap-2'>
                <div className='h-7 w-7 rounded-full bg-sd-muted'></div>
                <div className='h-7 w-7 rounded-full bg-sd-muted'></div>
                <div className='h-7 w-7 rounded-full bg-sd-muted'></div>
              </div>
              {/* Source/Dest */}
              <div className='space-y-2'>
                <div className='h-3 bg-sd-muted rounded w-20'></div>
                <div className='h-3 bg-sd-muted rounded w-20'></div>
              </div>
              {/* Description */}
              <div className='h-12 bg-sd-muted rounded'></div>
              {/* Actions */}
              <div className='flex gap-2 justify-end'>
                <div className='h-8 w-8 bg-sd-muted rounded-lg'></div>
                <div className='h-8 w-8 bg-sd-muted rounded-lg'></div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Desktop: Table Skeleton */}
      <div className='hidden lg:block overflow-x-auto'>
        <table className='w-full text-sm table-fixed'>
          <colgroup>
            <col className='w-[72px]' />
            <col className='w-[12%]' />
            <col className='w-[26%]' />
            <col className='w-[14%]' />
            <col />
            <col className='w-[110px]' />
          </colgroup>
          <thead>
            <tr className='border-b border-sd-border'>
              <th className='px-5 py-3.5 text-start text-xs font-semibold uppercase tracking-wider text-sd-muted-foreground'>
                Active
              </th>
              <th className='px-5 py-3.5 text-start text-xs font-semibold uppercase tracking-wider text-sd-muted-foreground'>
                Name
              </th>
              <th className='px-5 py-3.5 text-start text-xs font-semibold uppercase tracking-wider text-sd-muted-foreground'>
                Carriers
              </th>
              <th className='px-5 py-3.5 text-start text-xs font-semibold uppercase tracking-wider text-sd-muted-foreground'>
                Source/Dest
              </th>
              <th className='px-5 py-3.5 text-start text-xs font-semibold uppercase tracking-wider text-sd-muted-foreground'>
                Info
              </th>
              <th className='px-5 py-3.5 text-start text-xs font-semibold uppercase tracking-wider text-sd-muted-foreground'>
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {[1, 2, 3, 4, 5].map((i) => (
              <tr key={i} className='border-b border-sd-border'>
                <td className='px-5 py-4'>
                  <div className='animate-pulse'>
                    <div className='h-5 w-10 bg-sd-muted rounded-full'></div>
                  </div>
                </td>
                <td className='px-5 py-4'>
                  <div className='animate-pulse'>
                    <div className='h-4 bg-sd-muted rounded w-24'></div>
                  </div>
                </td>
                <td className='px-5 py-4'>
                  <div className='animate-pulse flex items-center'>
                    <div className='h-7 w-7 rounded-full bg-sd-muted'></div>
                    <div className='h-7 w-7 rounded-full bg-sd-muted -ml-2'></div>
                    <div className='h-7 w-7 rounded-full bg-sd-muted -ml-2'></div>
                  </div>
                </td>
                <td className='px-5 py-4'>
                  <div className='animate-pulse space-y-2'>
                    <div className='h-3 bg-sd-muted rounded w-20'></div>
                    <div className='h-3 bg-sd-muted rounded w-20'></div>
                  </div>
                </td>
                <td className='px-5 py-4'>
                  <div className='animate-pulse'>
                    <div className='h-12 bg-sd-muted rounded'></div>
                  </div>
                </td>
                <td className='px-5 py-4'>
                  <div className='animate-pulse flex gap-2'>
                    <div className='h-9 w-9 bg-sd-muted rounded-lg'></div>
                    <div className='h-9 w-9 bg-sd-muted rounded-lg'></div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination Skeleton */}
      <div className='flex items-center justify-between border-t border-sd-border px-4 py-3 sm:px-6'>
        <div className='animate-pulse'>
          <div className='h-4 bg-sd-muted rounded w-32'></div>
        </div>
        <div className='animate-pulse flex gap-2'>
          <div className='h-8 w-8 bg-sd-muted rounded'></div>
          <div className='h-8 w-8 bg-sd-muted rounded'></div>
          <div className='h-8 w-8 bg-sd-muted rounded'></div>
          <div className='h-8 w-8 bg-sd-muted rounded'></div>
        </div>
      </div>
    </div>
  );
}
